import type { UniversalModifierValue } from "schemas/generated/fileModifiers";

import React from "react";

import ContentModifierComponent from "./base/ContentModifier";
import PaddingModifierComponent from "./base/PaddingModifier";
import StyleModifier from "./base/StyleModifier";
import TextAlignmentModifierComponent from "./base/TextAlignmentModifier";
import TextColorModifierComponent from "./base/TextColorModifier";
import ModifierLayout from "./ModifierLayout";
import { useDefaultSelectedElementDesignation } from "./store/ModifiersStoreContext";

interface TextModifierBlockProps {
  onModifiersValueChange: (
    modifiers: UniversalModifierValue[],
    byteOffset: number,
  ) => void;
}

const TextModifierBlock: React.FC<TextModifierBlockProps> = ({
  onModifiersValueChange,
}) => {
  const defaultDesignation = useDefaultSelectedElementDesignation();

  if (!defaultDesignation) {
    return null;
  }

  const sections = [
    {
      rows: [
        {
          title: "Content",
          component: (
            <ContentModifierComponent
              onChange={(modifiers) =>
                onModifiersValueChange(
                  modifiers,
                  defaultDesignation.element.byteOffset,
                )
              }
            />
          ),
        },
        {
          title: "Alignment",
          component: (
            <TextAlignmentModifierComponent
              onChange={(modifiers) =>
                onModifiersValueChange(
                  modifiers,
                  defaultDesignation.element.byteOffset,
                )
              }
            />
          ),
        },
      ],
    },
    {
      rows: [
        {
          title: "Style",
          component: (
            <StyleModifier
              onChange={(modifiers) => {
                onModifiersValueChange(
                  modifiers,
                  defaultDesignation.element.byteOffset,
                );
              }}
            />
          ),
        },
        {
          title: "Color",
          component: (
            <TextColorModifierComponent
              onChange={(modifiers) =>
                onModifiersValueChange(
                  modifiers,
                  defaultDesignation.element.byteOffset,
                )
              }
            />
          ),
        },
      ],
    },
    {
      rows: [
        {
          title: "Padding",
          component: (
            <PaddingModifierComponent
              onChange={(modifiers) =>
                onModifiersValueChange(
                  modifiers,
                  defaultDesignation.element.byteOffset,
                )
              }
            />
          ),
        },
      ],
    },
  ];

  return (
    <ModifierLayout
      sections={sections}
      onModifiersValueChange={onModifiersValueChange}
    />
  );
};

export default TextModifierBlock;
